import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/api";

const LINKS = [
  { href: "#marcas", label: "Marcas" },
  { href: "#catalogo", label: "Catálogo" },
  { href: "#financiamiento", label: "Financiamiento" },
  { href: "#resenas", label: "Reseñas" },
  { href: "#ubicaciones", label: "Ubicaciones" },
];

export default function Navbar({ settings }) {
  return (
    <nav data-testid="main-nav" className="fixed inset-x-0 top-0 z-40 border-b border-border bg-white/90 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 md:px-8">
        <a href="#" data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/assets/logo.png" alt="Logo Electrodomésticos Rivera" className="h-11 w-11 rounded-full border border-border bg-white object-contain" data-testid="nav-logo-img" />
          <span className="leading-tight">
            <span className="block text-sm font-extrabold tracking-tight text-primary">Electrodomésticos Rivera</span>
            <span className="block text-[11px] font-medium text-muted-foreground">San Pedro Sula, Honduras</span>
          </span>
        </a>
        <div className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace("í", "i")}`}
              className="text-sm font-semibold text-primary/70 transition-colors duration-300 hover:text-primary"
            >
              {l.label}
            </a>
          ))}
        </div>
        <a
          data-testid="nav-whatsapp-cta"
          href={waLink(settings, "Hola Electrodomésticos Rivera, quiero cotizar un electrodoméstico.")}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex h-10 items-center gap-2 rounded-full bg-whatsapp px-4 text-sm font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5 md:px-5"
        >
          <MessageCircle className="h-4 w-4" />
          <span className="hidden sm:inline">Cotizar</span>
        </a>
      </div>
    </nav>
  );
}
